import { Breadcrumbs, Link, TablePagination, Typography } from "@mui/material";
import { useContratoListaViewModel } from "../../viewModels/contrato_lista_view_model";
import RefreshButton from "../../../../../common/components/refresh_button";
import PrimaryButton from "../../../../../common/components/primary_button";
import DynamicIcon from "../../../../../common/components/dynamic_icon";
import { PageTopBar, ThreeSlotLayout } from "../../../../../common/components/page_top_bar";
import { useMemo } from "react";
import { GenerateAvaliacaoColumns } from "./columns";
import { StyledDataGrid } from "../../../../../common/components/styled_data_grid";
import { Header } from "./components/header";
import DeleteDialog from "../../../../../common/components/delete_dialog";
import { useNavigate } from "react-router";
import { MedicaoTerceirizacaoLista } from "../../../domain/models/medicao_terceirizacao_lista";
import { useAvaliacaoFornecimentoListaViewModel } from "../../viewModels/avaliacao_fornecimento_lista_view_model";
import { LegendaModal } from "./components/legenda_modal";


export const AvaliacaoFornecimento_lista = () => {
  const viewModel = useAvaliacaoFornecimentoListaViewModel();
  const AvaliacaoListalColumns = useMemo(() => {
    return GenerateAvaliacaoColumns({
      onActionEditar: viewModel.handleCadastroMedicaoOpenState,
    });
  }, [viewModel.handleCadastroMedicaoOpenState]);

  return (
    <>
      <form>
        <div className="flex w-full gap-2 flex-col py-2 px-4 mb-20">
          <Breadcrumbs aria-label="breadcrumb" className="cursor-pointer">
            <Link underline="hover" color="inherit">
              Terceirização
            </Link>
            <Typography className="text-primary-green">
              Avalição de Fornecimento
            </Typography>
          </Breadcrumbs>
          <div className="div flex justify-between items-center flex-col gap-6">
            <div className="flex gap-2 items-center w-full">
              <h1 className="text-3xl font-medium text-black dark:text-white">Avaliação de Fornecimento</h1>
              <RefreshButton onClick={viewModel.handleReload} />
            </div>

            <Header
              onClearFilters={viewModel.handleClearFilters}
              centroDeCusto={viewModel.filters.centroDeCusto}
              centroDeCustoLista={viewModel.filters.centroDeCustoLista ?? []}
              FornecedorPesquisa={viewModel.filters.FornecedorPesquisa}
              NMedicaoPesquisa={viewModel.filters.NMedicaoPesquisa}
              StatusPesquisa={viewModel.filters.FornecedorAvaliadoPesquisa}
              NotaFiscalPesquisa={viewModel.filters.NotaFiscalPesquisa}
              ContratoPesquisa={viewModel.filters.ContratoPesquisa}
              handleContratoChange={viewModel.handleContratoChange}
              handleFornecedorChange={viewModel.handleFornecedorChange}
              handleCentroDeCusto={viewModel.handleCentroDeCustoChange}
              handleNMedicaoCampoChange={viewModel.handleNMedicaoCampoChange}
              handleStatusPesquisa={viewModel.handleFornecedorAvaliadoPesquisaChange}
              handleNotaFiscalPesquisa={viewModel.handleNotaFiscalPesquisa}
            />
            <div className="w-[180px]">
              <span
                className="text-[#009C4E] bg-transparent border border-[#009C4E] px-2 py-1 text-sm rounded rounded-base font-semibold cursor-pointer"
                onClick={() => viewModel.handleShowLegenda(true)}>
                Legenda
              </span>
            </div>
            <StyledDataGrid
              tableName="Avaliação_lista"
              disableColumnMenu={false}
              getRowId={(row: MedicaoTerceirizacaoLista) => row.IdMedicaoTerceirizacao}
              columns={AvaliacaoListalColumns}
              loading={viewModel.loading}
              rows={viewModel.AvaliacaoLista}
              rowCount={viewModel.pagination.totalItems}
              sx={{
                '& .status-header': {
                  backgroundColor: '#AFDFD5',
                  color: '#000'
                }
              }}
              pageSizeOptions={[10]}
              paginationMode="server"
              paginationModel={{
                page: viewModel.pagination.page,
                pageSize: viewModel.pagination.rowsPerPage,
              }}
              autoHeight={true}
              textSize="medio"
              getRowHeight={() => "auto"} />

            <TablePagination
              component="div"
              count={viewModel.pagination.totalItems}
              page={viewModel.pagination.page - 1}
              onPageChange={(_, p) => viewModel.handlePageChange(p)}
              rowsPerPageOptions={[10, 25, 50, 100]}
              rowsPerPage={viewModel.pagination.rowsPerPage}
              onRowsPerPageChange={(e) => viewModel.handleRowsPerPageChange(parseInt(e.target.value))} />
          </div>

          <Header
            onClearFilters={viewModel.handleClearFilters}
            centroDeCusto={viewModel.filters.centroDeCusto}
            centroDeCustoLista={viewModel.filters.centroDeCustoLista ?? []}
            FornecedorPesquisa={viewModel.filters.FornecedorPesquisa}
            NMedicaoPesquisa={viewModel.filters.NMedicaoPesquisa}
            StatusPesquisa={viewModel.filters.FornecedorAvaliadoPesquisa}
            NotaFiscalPesquisa={viewModel.filters.NotaFiscalPesquisa}
            ContratoPesquisa={viewModel.filters.ContratoPesquisa}
            handleContratoChange={viewModel.handleContratoChange}
            handleFornecedorChange={viewModel.handleFornecedorChange}
            handleCentroDeCusto={viewModel.handleCentroDeCustoChange}
            handleNMedicaoCampoChange={viewModel.handleNMedicaoCampoChange}
            handleStatusPesquisa={viewModel.handleFornecedorAvaliadoPesquisaChange}
            handleNotaFiscalPesquisa={viewModel.handleNotaFiscalPesquisa}
          />
          <div className="w-[180px]">
            <span
              className="text-[#009C4E] bg-transparent border border-[#009C4E] px-2 py-1 text-sm rounded rounded-base font-semibold cursor-pointer"
              onClick={() => viewModel.handleShowLegenda(true)}>
              Legenda
            </span>
          </div>
          <StyledDataGrid
            tableName="Avaliação_lista"
            disableColumnMenu={false}
            getRowId={(row: MedicaoTerceirizacaoLista) => row.IdMedicaoTerceirizacao}
            columns={AvaliacaoListalColumns}
            loading={viewModel.loading}
            rows={viewModel.AvaliacaoLista}
            rowCount={viewModel.pagination.totalItems}
            sx={{
              '& .status-header': {
                backgroundColor: '#AFDFD5',
                color: '#000'
              }
            }}
            pageSizeOptions={[10]}
            paginationMode="server"
            paginationModel={{
              page: viewModel.pagination.page,
              pageSize: viewModel.pagination.rowsPerPage,
            }} />

          <TablePagination
            component="div"
            count={viewModel.pagination.totalItems}
            page={viewModel.pagination.page - 1}
            onPageChange={(_, p) => viewModel.handlePageChange(p)}
            rowsPerPageOptions={[10, 25, 50, 100]}
            rowsPerPage={viewModel.pagination.rowsPerPage}
            onRowsPerPageChange={(e) => viewModel.handleRowsPerPageChange(parseInt(e.target.value))} />
        </div>
      </form>
      <LegendaModal
        open={viewModel.openLegendaModal}
        onClose={() => viewModel.handleShowLegenda(false)}
      />
    </>
  );

}


